import sendoff from "../data/eventpics/sendoff2022.png";
import frosh from "../data/eventpics/frosh.png";
import welcome from "../data/eventpics/welcomeparty.png";
import ski from "../data/eventpics/ski.jpg";
import lny from "../data/eventpics/lny.png";

const images = [
    {src: lny, link: "https://fb.me/e/3SYJWtGbN", description:"Lunar New Year"},
    {src: ski, description: "Ski Trip"},
    {src: welcome, link: "https://www.facebook.com/events/482694906775426", description: "MTSA Welcome Party"},
    {src: frosh, link: "https://fb.me/e/2nWyB2PX1", description:"MTSA Frosh: Top Fun Montreal"},
    {src: sendoff, link: "https://fb.me/e/8HNVJjrQ1", description:"Send Off"}

];

export default images;